import { FirstTimeConsentToUsageAnalyticsDialog } from '@/google-tag-manager/first-time-consent-to-usage-analytics-dialog';
import { getFromLocalStorage, setLocalStorage } from '@/local-storage/utils';
import { useMsalAccount } from '@/auth/use-msal-account';
import { useState } from 'react';

export const FirstLoginUsageAnalyticsDialog = () => {
  const { activeAccount } = useMsalAccount();

  const [isUsageStatisticsConsentDialogOpen, setIsUsageStatisticsConsentDialogOpen] = useState(
    getFromLocalStorage('accepted-terms') == 'true' &&
      getFromLocalStorage('usage-analytics-enabled') == undefined
  );

  if (!activeAccount) return null;

  return (
    <FirstTimeConsentToUsageAnalyticsDialog
      isOpen={isUsageStatisticsConsentDialogOpen}
      onOpenChange={(newValue) => {
        if (newValue) {
          setLocalStorage('usage-analytics-enabled', 'true');
        } else {
          setLocalStorage('usage-analytics-enabled', 'false');
        }

        setIsUsageStatisticsConsentDialogOpen(false);
      }}
    />
  );
};
